<script setup lang="ts">

</script>

<template>
  <div class="content">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.content {
  @apply w-full max-w-[940px] h-full pt-8 border-x border-default/10;
  min-height: calc(100vh - 4rem - 4rem);

  @include mobile {
    @apply mx-4 max-w-[calc(100%-2rem)] pt-4;
  }
}
</style>